export const SET_DOCUMENT_TYPE = 'SET_DOCUMENT_TYPE'
export const SET_ROOM_ID = 'SET_ROOM_ID'
export const SET_SOCKET = 'SET_SOCKET'
export const SET_MOBILE_NUMBER = 'SET_MOBILE_NUMBER'
export const SET_CLIENT_SUCCESS = 'SET_CLIENT_SUCCESS'
export const MOBILE_CONNECTED = 'MOBILE_CONNECTED'
export const ACCEPT_TERMS = 'ACCEPT_TERMS'
export const SET_FULL_SCREEN = 'SET_FULL_SCREEN'

export const CAPTURE_CREATE = 'CAPTURE_CREATE'
export const CAPTURE_DELETE = 'CAPTURE_DELETE'

export const RESET_STORE = 'RESET_STORE'



// WEBPACK FOOTER //
// ./core/constants/index.js